import { useCallback, useEffect, useState } from "react";
import type { ApolloError } from "@apollo/client";

const MAX_RETRIES = 1;

export interface UseRetryOptions {
  requestError: ApolloError | undefined;
  refetch: () => unknown;
  maxRetries?: number;
}

export interface UseRetryReturn {
  finalError: ApolloError | null;
  resetRetries: () => void;
}

const useRetry = ({
  requestError,
  refetch,
  maxRetries = MAX_RETRIES,
}: UseRetryOptions): UseRetryReturn => {
  const [retryCount, setRetryCount] = useState(0);
  const [finalError, setFinalError] = useState<ApolloError | null>(null);

  useEffect(() => {
    if (!!requestError) {
      if (retryCount < maxRetries) {
        setRetryCount((prevCount) => prevCount + 1);
        refetch();
      } else {
        setFinalError(requestError);
      }
    }
  }, [requestError]);

  const resetRetries = useCallback(() => {
    setRetryCount(0);
    setFinalError(null);
  }, []);

  return { finalError, resetRetries };
};

export default useRetry;
